import React from 'react';
import checked from '../../../shared/icons/images/radio-checked.svg?url';
import unchecked from '../../../shared/icons/images/radio-unchecked.svg?url';
import bankIdLogo from './icons/bankid_logo.svg?url';
import vippsLogo from './icons/vipps_logo.svg?url';

import './verification.scss';

const providerConfig = [
  {
    key: 'Vipps',
    displayName: 'Vipps',
    imgSrc: vippsLogo,
  },
  {
    key: 'BankID',
    displayName: 'BankID',
    imgSrc: bankIdLogo,
  },
] as const;

export const VerificationProviderSelection: React.FC<{
  selectedProvider: string;
  handleProviderChange: React.ChangeEventHandler<HTMLInputElement>;
}> = ({ selectedProvider, handleProviderChange }) => {
  return (
    <div>
      {providerConfig.map((provider) => {
        const radioButtonId = `${provider.key}RadioBtn`;
        const isChecked = selectedProvider === provider.key;
        return (
          <div className="radio-verification-button" key={`key${radioButtonId}`}>
            <input
              className="left"
              id={radioButtonId}
              type="radio"
              value={provider.key}
              name="verificationProvider"
              onChange={handleProviderChange}
              checked={isChecked}
            />
            <label className="click-area" htmlFor={radioButtonId}>
              <img className="radio-icon" src={isChecked ? checked : unchecked} alt="" />
              <span className="display-text">{provider.displayName}</span>
              <img className="provider-logo" src={provider.imgSrc} alt="" />
            </label>
          </div>
        );
      })}
    </div>
  );
};
